module.exports = __webpack_public_path__ + "img/clavis-riga.985af011.jpg";